import _ from 'lodash';
import companiesBudgetsReducer from '../reducers/companiesBudgets';
import api from '../../services/api';
import { SELECTOR_COMPANIES_BUDGETS_TOTALS } from '../selectors/companiesBudgets';
export function getCompanyBudgetById(id) {
  return (dispatch) => {
    dispatch(companiesBudgetsReducer.Creators.setCompaniesBudgetSelected(Number(id)));
    return api.companiesBudgets.get(id).then((companyBudget) => {
      dispatch(companiesBudgetsReducer.Creators.addCompaniesBudgets([companyBudget]));
      return companyBudget;
    })
  }
}

export function getCompaniesBudgets(query = {}) {
  return (dispatch) => {
    return api.companiesBudgets
      .find(_.merge({query: {$sort: {id: [-1]}, $limit: 10}}, query))
      .then(({data: companiesBudgets, ...totals}) => {
        dispatch(companiesBudgetsReducer.Creators.setCompaniesBudgets(companiesBudgets));
        dispatch(companiesBudgetsReducer.Creators.setCompaniesBudgetsTotals(totals));
        return {data: companiesBudgets, ...totals};
      })
  }
}

export function createCompanyBudget(values) {
  return (dispatch, getState) => {
    return api.companiesBudgets.create(values).then((companyBudget) => {
      const totals = SELECTOR_COMPANIES_BUDGETS_TOTALS(getState());
      dispatch(companiesBudgetsReducer.Creators.addCompaniesBudgets([companyBudget]));
      dispatch(companiesBudgetsReducer.Creators.setCompaniesBudgetsTotals({...totals, total: totals.total + 1 }))
      return companyBudget;
    })
  }
}

export function updateCompanyBudget(id, values) {
  return (dispatch) => {
    return api.companiesBudgets.patch(id, values).then((companyBudget) => {
      dispatch(companiesBudgetsReducer.Creators.addCompaniesBudgets([companyBudget]));
      return companyBudget;
    })
  }
}

export function deleteCompanyBudget(id) {
  return (dispatch) => {
    return api.companiesBudgets.remove(id).then((companyBudget) => {
      dispatch(companiesBudgetsReducer.Creators.delCompaniesBudgets([companyBudget]));
      return companyBudget;
    }) 
  }
}